export default "__VITE_ASSET__BopEGrBi__"